import React, { useEffect, useState } from 'react';
import { Link as LinkS } from 'react-scroll';
import './NavPage.css';
import { AiOutlineHome } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { MdKeyboardDoubleArrowUp, MdKeyboardDoubleArrowDown } from "react-icons/md";


const useScrollSpy = (sectionIds, offset = 0) => {
    const [activeSection, setActiveSection] = useState(null);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight / 2;

            for (const id of sectionIds) {
                const element = document.querySelector(id);
                if (element && element.offsetTop <= scrollPosition && element.offsetTop + element.offsetHeight > scrollPosition) {
                    setActiveSection(id);
                    break;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [sectionIds, offset]);

    return activeSection;
};

const NavPage = () => {
    const sectionIds = ['#GPage', '#End'];
    const activeNav = useScrollSpy(sectionIds);




    return (
        <nav className='showNav' >
            <LinkS data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="800"
                data-aos-offset="0" to="PageHL" className={activeNav === '#GPage' ? 'active' : ''} smooth={true} duration={500}><MdKeyboardDoubleArrowUp /></LinkS>
            <Link data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="200"
                data-aos-offset="0" to="/" smooth="true" duration={1500}><AiOutlineHome /></Link>
            <LinkS data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration="800"
                data-aos-offset="0" to="End" className={activeNav === '#End' ? 'active' : ''} smooth={true} duration={500}><MdKeyboardDoubleArrowDown /></LinkS>
        </nav>
    );
};

export default NavPage;
